import { lazy } from 'react';

export const pageImports = {
  '/': () => import('../pages/signup/signup'),
  '/signin': () => import('../pages/signup/signin'),
  '/forgot-password': () => import('../pages/forgotPassword'),
  '/privacy-policy': () => import('../pages/PrivacyPolicy'),
  '/terms-conditions': () => import('../pages/TermsAndConditions'),
  '/home': () => import('../pages/home'),
  '/moredetails': () => import('../pages/signup/moreDetails'),
  '/service': () => import('../pages/selectService'),
  '/profile': () => import('../pages/profile'),
  '/servicedetail': () => import('../pages/serviceDetail'),
  '/selectarea': () => import('../pages/selectArea'),
  '/solution': () => import('../pages/solution'),
  '/basket': () => import('../pages/basket'),
  '/selectarealand': () => import('../pages/selectAreaLand'),
  '/payment': () => import('../pages/payment'),
  '/orderdetails': () => import('../pages/orderDetails'),
  '/order': () => import('../pages/order'),
  '/orderlist': () => import('../pages/orderList'),
  '/orderlist-details': () => import('../pages/orderListDetail'),
  '/orderanalys': () => import('../pages/orderAnalys'),
  '/orderreport': () => import('../pages/orderReport'),
  '/helpcenter': () => import('../pages/helpCenter'),
  '/wallet': () => import('../pages/wallet'),
  '/chatbot': () => import('../components/Chatbot/ChatBot'),
  '/change-password': () => import('../pages/changePassword'),
  '/analysis-report': () => import('../pages/orderAnalysis'),
  '/refferal-users': () => import('../pages/referralUser'),
  '/area-interests': () => import('../pages/areaInterestList'),
  '/area-interest-add': () => import('../pages/areaInterestAdd'),
  '/add-address': () => import('../pages/SaveAddress'),
};

const lazyPage = (path) => lazy(pageImports[path]);

export const prefetchRoute = (path) => {
  const load = pageImports[path];
  if (load) load();
};

export const Signup = lazyPage('/');
export const Signin = lazyPage('/signin');
export const ForgotPassword = lazyPage('/forgot-password');
export const PrivacyPolicy = lazyPage('/privacy-policy');
export const TermsAndConditions = lazyPage('/terms-conditions');
export const Home = lazyPage('/home');
export const MoreDetails = lazyPage('/moredetails');
export const Service = lazyPage('/service');
export const Profile = lazyPage('/profile');
export const ServiceDetail = lazyPage('/servicedetail');
export const SelectArea = lazyPage('/selectarea');
export const Solution = lazyPage('/solution');
export const Basket = lazyPage('/basket');
export const SelectAreaLand = lazyPage('/selectarealand');
export const Payment = lazyPage('/payment');
export const OrderDetails = lazyPage('/orderdetails');
export const Order = lazyPage('/order');
export const OrderList = lazyPage('/orderlist');
export const OrderListDetail = lazyPage('/orderlist-details');
export const OrderAnalys = lazyPage('/orderanalys');
export const OrderReport = lazyPage('/orderreport');
export const HelpCenter = lazyPage('/helpcenter');
export const Wallet = lazyPage('/wallet');
export const ChatBot = lazyPage('/chatbot');
export const ChangePassword = lazyPage('/change-password');
export const OrderAnalysis = lazyPage('/analysis-report');
export const ReferralUser = lazyPage('/refferal-users');
export const AreaInterestList = lazyPage('/area-interests');
export const AreaInterestAdd = lazyPage('/area-interest-add');
export const SaveAddress = lazyPage('/add-address');
export const NotFound = lazy(() => import('../pages/NotFound'));
